import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Image from "next/image";
import chessImg from "../../public/images/sports/menfis_chess.jpg";
import swimmingImg from "../../public/images/sports/menfis_sports_3.jpg";


const RecreationalActivities = () => {
  return (
    <>
      <PageHead title="Actividades Lúdicas - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Actividades Lúdicas" text="Actividades Lúdicas" />
          
          <div className=" bg-color-white rbt-section-gap2Top" id="soccer">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <div className="flex-center ">
                    <video width="360" height="520" poster="/images/partners/logo.png" controls>
                      <source src="/video/menfis_football.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Fútbol</h4>
                    <p className="description mt--20">
                      <b>Entrenador:</b><br/> Jorge Mendoza - Profe Ara
                    </p>
                    <p className="description mt--20">
                      <b>Horario:</b><br/> Lunes y jueves: 4:40pm a 5:50pm <br/> Viernes: 12:30m a 1:00pm
                    </p>
                    <p className="description mt--20">
                      <b>Costo mensual:</b><br/> $ 50.000
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-color-white rbt-section-gap2Top" id="swimming">
            <div className="container">
              <div className="row g-5 align-items-center flex-center">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={swimmingImg}
                    width={550}
                    height={600}
                    property="true"
                    alt="Swimming image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Natación</h4>
                    <p className="description mt--20">
                      <b>Entrenadora:</b><br/> Sandra Milena Saldarriaga
                    </p>
                    <p className="description mt--20">
                      <b>Horario:</b><br/> Lunes, miércoles y jueves: 4:40pm a 5:50pm
                    </p>
                    <p className="description mt--20">
                      <b>Costo mensual:</b><br/> $ 50.000
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top rbt-section-gap2Bottom" id="chess">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={chessImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Chess image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Ajedrez</h4>
                    <p className="description mt--20">
                      <b>Entrenadora:</b><br/> Daniela Gil
                    </p>
                    <p className="description mt--20">
                      <b>Horario:</b><br/> Lunes, martes y miércoles: 4:40pm a 5:45pm
                    </p>
                    <p className="description mt--20">
                      <b>Costo mensual:</b><br/> $ 50.000
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white mt--30 rbt-section-gap2Bottom flex-center">
            <div className="container col-lg-8">
              <p className="description text-align-center">
                *Estos horarios están sujetos a cambios para el 2026
              </p>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default RecreationalActivities;
